import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { GridToolbar, DataGrid } from "@mui/x-data-grid";

const columns = [
   { field: "id", headerName: "Player ID", width: 100 },
   {
      field: "LastName",
      headerName: "last name",
      width: 180,
   },
   {
      field: "FirstName",
      headerName: "First name",
      width: 180,
   },
   {
      field: "HOF",
      headerName: "HOF",
      width: 125,
   },
   {
      field: "Country",
      headerName: "Country",
      width: 180,
   },
   {
      field: "Archetype",
      headerName: "Archetype",
      width: 400,
   },
];

export default function PlayerSelect({ callback, selectedRows, rows }) {

   console.log(rows);

   const [currentSelectedRows, setCurrentSelectedRows] = useState(
      JSON.parse(selectedRows)
   );

   useEffect(() => {
      if (currentSelectedRows != selectedRows) {
         callback(currentSelectedRows);
      }
   }, [currentSelectedRows]);

   return (
      <Box sx={{ height: 600, width: "100%" }}>
         <DataGrid
            slots={{ toolbar: GridToolbar }}
            rows={rows.map(row => ({...row, id: row.id}))}
            columns={columns}
            initialState={{
               pagination: {
                  paginationModel: {
                     pageSize: 25,
                  },
               },
            }}
            pageSizeOptions={[25]}
            checkboxSelection
            disableRowSelectionOnClick
            selectionModel={currentSelectedRows}
            onSelectionModelChange={(newSelection) => {
               setCurrentSelectedRows(newSelection);
            }}
         />
      </Box>
   );
}
